import { TrendingUp, Plug, ArrowRight } from 'lucide-react';

/**
 * Powersure — Wat doet Powersure?
 * 3 korte dark cards die binnen 5 seconden uitleggen wat de klant krijgt.
 */
export default function PowersureWhatItDoesSection() {
  const items = [
    {
      icon: TrendingUp,
      title: 'Top 3 kansen',
      desc: 'Powersure laat zien welke 3 stappen waarschijnlijk het meeste opleveren — gerangschikt op impact, zonder kilowatt-jargon.',
      example: '→ Aanbevolen · Eerst meten · Later plannen',
    },
    {
      icon: Plug,
      title: 'Apparaten koppelen',
      desc: 'Voeg apparaten toe of laat Powersure ze herkennen. P1-meter, omvormer, laadpaal, warmtepomp, batterij — alles in één overzicht.',
      example: '→ 12 categorieën ondersteund',
    },
    {
      icon: ArrowRight,
      title: 'Uw beste volgende stap',
      desc: 'Powersure vertelt u rustig wat de slimste eerstvolgende actie is. Geen druk, geen verplichtingen, geen verkoper aan de telefoon.',
      example: '→ Bekijk → Beslis → Plan',
    },
  ];

  return (
    <section
      className="py-16 sm:py-20"
      style={{ background: 'linear-gradient(180deg, #0e1b16 0%, #0a1410 100%)' }}
      data-testid="powersure-whatitdoes-section"
    >
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="text-[11px] uppercase tracking-[0.2em] text-emerald-300/90 font-semibold">
              Wat doet Powersure?
            </span>
          </div>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-medium text-white max-w-2xl mx-auto leading-tight"
            style={{ fontFamily: 'Outfit' }}
          >
            Inzicht, koppelen en uw volgende stap — in één app.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                data-testid={`powersure-whatitdoes-card-${i}`}
                className="rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 p-6 hover:border-emerald-400/30 transition-colors"
              >
                <div className="w-11 h-11 rounded-xl bg-emerald-500/15 border border-emerald-400/30 flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5 text-emerald-300" />
                </div>
                <h3
                  className="text-lg font-medium text-white mb-2"
                  style={{ fontFamily: 'Outfit' }}
                >
                  {item.title}
                </h3>
                <p className="text-sm text-white/70 leading-relaxed mb-3">{item.desc}</p>
                <p className="text-xs font-medium text-emerald-300/90">{item.example}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
